<template lang="html">
    <div class="" style="height:100%;">
		<el-card class="box-card" style="margin-top: 20px;">
			<div slot="header">公告管理 ></div>
			<div>
				<el-input type="textarea" :rows="6" maxlength="100" resize="none" v-model="content" placeholder="请输入内容" size="small" ></el-input>
				<el-button type="primary" size="small" style="margin:50px auto 0;display: block;width:100%" @click="submit">确定</el-button>
			</div>
		</el-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            content:'',
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            this.http.post('/admin/notice/read').then(re => {
                this.content = re.content;
            })
        },

        submit() {
            if (!this.content) {
                this.$message.error('不得为空！')
            } else {
                this.http.post('/admin/notice/edit', {content:this.content}).then(() => {
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                })
            }
        }
    }
}
</script>
